import TagGroupItem, { TagGroupItemProps } from './TagGroupItem';

export type { TagGroupItemProps };
export default TagGroupItem;
